import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import Alert from "./Usersmanagement/Element/alert";

function Login({ setUserId1 }) {
    const [alerts, setAlerts] = useState([]);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [serverDown, setServerDown] = useState(false);

    const navigate = useNavigate();

    const addAlert = (message, type) => {
        const id = Date.now() + Math.random();
        const newAlert = { id, message, type };
        setAlerts(prev => [...prev, newAlert]);

        // Auto remove after 3 seconds
        setTimeout(() => {
            setAlerts(prev => prev.filter(alert => alert.id !== id));
        }, 3000);
    };

    const removeAlert = (id) => {
        setAlerts(prev => prev.filter(alert => alert.id !== id));
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;

        setServerDown(false);
        setIsSubmitting(true);

        try {
            const res = await fetch("https://api.magsayo.net/api/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ username, password })
            });

            if (!res.ok) {
                if (res.status >= 500) {
                    setServerDown(true);
                    addAlert("Server unavailable. Please try again later.", "danger");
                } else {
                    try {
                        if (res.headers.get('content-type')?.includes('application/json')) {
                            const data = await res.json();
                            addAlert(data.message || "Invalid username or password", "danger");
                        } else {
                            addAlert("Invalid response from server", "danger");
                        }
                    } catch (parseError) {
                        addAlert("Invalid response from server", "danger");
                    }
                }
                setIsSubmitting(false);
                return;
            }

            try {
                if (res.headers.get('content-type')?.includes('application/json')) {
                    const data = await res.json();
                    if (data.success) {
                        localStorage.setItem('token', data.token);
                        addAlert("Welcome!", "success");
                        setTimeout(() => {
                            setUserId1(data.user.id);
                            navigate('/');
                        }, 1500);
                    } else {
                        addAlert(data.message || "Invalid username or password", "danger");
                    }
                } else {
                    addAlert("Invalid response from server", "danger");
                }
            } catch (parseError) {
                addAlert("Invalid response from server", "danger");
            }
        } catch (error) {
            console.error("Error fetching login data:", error);
            setServerDown(true);
            addAlert("Login failed: Backend down", "danger");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <main>
                <div className="container">

                    <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                                    <div className="d-flex justify-content-center py-4">
                                        <a href="index.html" className="logo d-flex align-items-center w-auto">
                                            <img src="assets/img/logo.png" alt="" />
                                            <span className="d-none d-lg-block">Magsayo Admin</span>
                                        </a>
                                    </div>
                                    {/* <!-- End Logo --> */}

                                    <div className="card mb-3">

                                        <div className="card-body">

                                            <div className="pt-4 pb-2">
                                                <h5 className="card-title text-center pb-0 fs-4">Login to Your Account</h5>
                                            </div>

                                            <form className="row g-3 needs-validation" noValidate onSubmit={handleLogin}>

                                                <div className="col-12">
                                                    <label htmlFor="yourUsername" className="form-label">Username</label>
                                                    <div className="input-group has-validation">
                                                        <input type="text" name="username" className="form-control" id="yourUsername" autoComplete="username"
                                                            // placeholder="Username"
                                                            value={username}
                                                            onChange={(e) => setUsername(e.target.value)}
                                                            required />
                                                        <div className="invalid-feedback">Please enter your username.</div>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <label htmlFor="yourPassword" className="form-label">Password</label>
                                                    <input type="password" name="password" className="form-control" id="yourPassword" autoComplete="current-password"
                                                        // placeholder="Password"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)} required />
                                                    <div className="invalid-feedback">Please enter your password!</div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="remember" value="true" id="rememberMe" disabled={isSubmitting || serverDown} />
                                                        <label className="form-check-label" htmlFor="rememberMe">Remember me</label>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <button className="btn btn-primary w-100" type="submit" disabled={isSubmitting || serverDown}>
                                                        {isSubmitting ? 'Logging in...' : serverDown ? 'Server unavailable' : 'Login'}
                                                    </button>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                    <div className="credits">
                                    Designed by <a href="">Magsayo Developers</a>
                                </div>
                            </div>
                        </div>
                </div>

            </section>

        </div >
            </main >
        {/* <!-- End #main --> */ }
        {alerts.map((alert, index) => (
            <Alert
                key={alert.id}
                show={true}
                message={alert.message}
                type={alert.type}
                onClose={() => removeAlert(alert.id)}
                style={{ top: `${10 + index * 70}px` }}
            />
        ))}
        </>
    );
}

export default Login;